import React from 'react'

function Speaking() {
  return (
    <div>Speaking</div>
  )
}

export default Speaking
